import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileCheck, Clock, CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";

export default function Handler() {
  const [queue, setQueue] = useState([]);
  const [docs, setDocs] = useState([]);

  const load = async () => {
    const [q, d] = await Promise.all([api.get("/handler/queue"), api.get("/handler/documents/pending")]);
    setQueue(q.data.queue); setDocs(d.data.documents);
  };
  useEffect(() => { load(); }, []);

  const review = async (id, status) => {
    try {
      await api.patch(`/documents/${id}/review`, { review_status: status });
      toast.success(status === "approved" ? "Approved" : "Rejected");
      load();
    } catch { toast.error("Failed"); }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-10 pb-24">
      <div className="text-xs uppercase tracking-widest text-muted font-semibold">Handler</div>
      <h1 className="mt-2 text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight">Case handler workspace</h1>

      <div className="mt-8 grid md:grid-cols-2 gap-5">
        <div className="moe-panel-mint p-6">
          <div className="text-xs uppercase tracking-widest font-bold">Assigned queue</div>
          <div className="mt-4 space-y-3 moe-stagger">
            {queue.map((c) => (
              <div key={c.id} className="p-3 rounded-lg bg-white">
                <div className="flex items-center justify-between">
                  <div className="text-sm font-bold">{c.student?.name}</div>
                  <span className="moe-chip">{c.country}</span>
                </div>
                <div className="text-xs text-muted mt-1">{c.host_university} · {c.duration_days}d · starts {c.start_date}</div>
                <div className="text-xs text-muted mt-1">Visa: {c.visa_path?.visa_type}</div>
                {c.pending_documents > 0 && (
                  <span className="mt-2 inline-flex moe-chip moe-chip-yolk moe-pulse"><Clock size={11}/> {c.pending_documents} to review</span>
                )}
              </div>
            ))}
            {queue.length === 0 && <div className="text-sm text-ink/70">No cases yet.</div>}
          </div>
        </div>

        <div className="moe-panel-cyan p-6">
          <div className="text-xs uppercase tracking-widest font-bold">Documents awaiting review</div>
          <div className="mt-4 space-y-3 moe-stagger">
            {docs.map((d) => (
              <div key={d.id} className="p-3 rounded-lg bg-white">
                <div className="flex items-center gap-2"><FileCheck size={14} className="text-elec"/><div className="text-sm font-semibold">{d.name}</div></div>
                {d.file_url && <a href={d.file_url} target="_blank" rel="noreferrer" className="text-xs text-muted hover:text-elec block truncate">{d.file_url}</a>}
                <div className="mt-2 flex gap-2">
                  <button onClick={()=>review(d.id, "approved")} className="moe-btn moe-btn-primary !py-1 !px-3 text-xs"><CheckCircle2 size={12}/> Approve</button>
                  <button onClick={()=>review(d.id, "rejected")} className="moe-btn moe-btn-ghost !py-1 !px-3 text-xs"><XCircle size={12}/> Reject</button>
                </div>
              </div>
            ))}
            {docs.length === 0 && <div className="text-sm text-ink/70">Nothing to review right now.</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
